// extracted by mini-css-extract-plugin
module.exports = {"header__search-bar":"search-bar_header__search-bar__1KtYI"};